import { DialogComponent } from "@theme/dialog";

/**
 * Simple dialog controller that hosts a slideshow-component.
 *
 * Expected DOM structure:
 *
 * <carousel-dialog-component>
 *   <dialog ref="dialog" class="media-slideshow-dialog" ...>
 *     <slideshow-component ref="slideshow">...</slideshow-component>
 *   </dialog>
 * </carousel-dialog-component>
 */
export class CarouselDialogComponent extends DialogComponent {
  /** @type {Array<keyof import("./carousel-dialog").CarouselDialogComponent["refs"]>} */
  requiredRefs = ["dialog", "slideshow"];

  /**
   * Opens the dialog and selects the given slide index.
   *
   * @param {number|Event} input
   * @param {PointerEvent} [event]
   */
  open(input, event) {
    const index = Number(input);
    const evt = event;

    this.showDialog();

    requestAnimationFrame(() => {
      this.refs.slideshow?.select?.(index, evt, { animate: false });
    });
  }
}

if (!customElements.get("carousel-dialog-component")) {
  customElements.define("carousel-dialog-component", CarouselDialogComponent);
}

